import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../styles/Header.css";
import logo from "../assets/logo.png";
import { User } from "../types/User";

interface HeaderProps {
  user: User;
  logout?: () => void;
}


const Header: React.FC<HeaderProps> = ({ user, logout }) => {
  const displayName = user.username || user.nom;

  return (
    // header is full-width; inner .container (.header-card) is the visual card aligned with pages
    <header className="navbar header">
      <div className="container d-flex align-items-center justify-content-between shadow-sm header-card px-3 py-2">
        {/* Logo + titre */}
        <div className="d-flex align-items-center mb-0">
          <img src={logo} alt="Logo" className="header-logo" />
          <h4 className="ms-3 fw-bold mb-0 text-success d-none d-md-block">
            Plateforme de récolte de données
          </h4>
        </div>

        {/* Profil + déconnexion */}
        <div className="d-flex align-items-center">
          <div className="me-3 d-flex align-items-center">
            <i className="bi bi-person-circle text-success me-2 fs-5"></i>
            <span className="fw-semibold d-none d-md-inline">{displayName}</span>
          </div>
          <span className="separator mx-2"></span>
          <button onClick={logout} className="btn btn-outline-success btn-sm rounded-pill">
            <i className="bi bi-box-arrow-right fs-5"></i>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
